import React, { useState } from 'react';
import { Form, Input } from 'antd';
import { toRenderedDate, validateBirthDate } from '../validators/date-validator';
import PropTypes from 'prop-types';

const FIELD_NAME = 'dateOfBirth';
const getDateMask = (lang) => lang === 'es' ? 'DD/MM/AAAA' : 'DD/MM/YYYY';
const getYearToken = (lang) => lang === 'es' ? 'A' : 'Y';

const DateOfBirthField = ({ lang, form, birthDate, getFieldDecorator }, context) => {
  const initialText = toRenderedDate(birthDate) || getDateMask(lang);
  const [dateText, setDateText] = useState(initialText);

  const removeLastDigit = () => {
    const SENTINEL = '*';
    const dateCopy = `_${dateText}`.slice(1);
    const dateWithSentinel = dateCopy.replace(/(\d)(?!.*\d)/, SENTINEL);

    const tokens = dateWithSentinel.split('/');
    let patternChar;
    if (tokens[0].includes(SENTINEL)) {
      patternChar = 'D';
    } else if (tokens[1].includes(SENTINEL)) {
      patternChar = 'M';
    } else {
      patternChar = getYearToken(lang);
    }
    return dateWithSentinel.replace(SENTINEL, patternChar);
  };

  const setNextDigit = (char) => {
    const dateCopy = `_${dateText}`.slice(1);
    return dateCopy.replace(/(D|M|Y|A)/, char);
  };

  const onInput = (ev) => {
    const keyChar = ev.key;
    const isNumber = /^\d+$/.test(keyChar);

    let updatedDate;
    if (keyChar === 'Backspace') {
      updatedDate = removeLastDigit();
    } else if (isNumber) {
      updatedDate = setNextDigit(keyChar);
    } else {
      updatedDate = dateText;
    }
    setDateText(updatedDate);
    return updatedDate;
  }

  return (
    <Form.Item label={context.t('Date of Birth')} hasFeedback>
      {getFieldDecorator(FIELD_NAME, {
        initialValue: initialText,
        rules: [
          { validator: validateBirthDate(form, context) }
        ],
        trigger: 'onKeyUp',
        getValueFromEvent: onInput,
      })(<Input size="large" inputMode="numeric" type="text"/>)}
    </Form.Item>
  );
};


DateOfBirthField.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default DateOfBirthField;
